const getRanges = (from, to) => {
  let range = {}
  if (from) {
    range.from = [
      ...from
    ]
  }
  if (to) {
    range.to = [
      ...to
    ]
  }
  return range
}
const engCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
const engOptions = getRanges(engCount, engCount)

const followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
const followerOptions = getRanges(followersCount, followersCount)

let engRatePercentageCount = [];
for (let i = 0; i < 20; i++) {
  engRatePercentageCount.push(`>= ${i}.0 %`)
}
const engRatePercentageOptions = getRanges(engRatePercentageCount, false)
const percentOptions = [
  '≥1%',
  '≥5%',
  '≥10%',
  '≥15%',
  '≥20%',
  '≥25%',
  '≥30%',
  '≥35%',
  '≥40%',
  '≥45%',
  '≥50%',
  '≥55%',
  '≥60%',
  '≥65%',
  '≥70%',
  '≥75%',
  '≥80%',
  '≥85%',
  '≥90%',
  '≥95%'
]
const searchSettings = {
  relevantKeywords: 0,
  distance: 0,
  frequency: 0,
  influencerGeos: ['Singapore'],
  audGeos: ['Singapore'],
  audGeoPercent: '≥5%',
  infGender: 'KNOWN',
  audGender: '',
  audGenderPercent: '',
  followers: {from: '1K', to: ''},
  engagements: {from: '', to: ''},
  engagementRate: {from: ''},
  bio: '',
  keywords: '',
  mentions: [],
  hashtags: []
}

const localTableHeaders = [
  {
    value: 'handle',
    text: 'Handle'
  },
  {
    value: 'fullName',
    text: 'Full Name'
  },
  {
    value: 'tags',
    text: 'Tags',
    sortable: false
  },
  {
    value: 'totalFollowers',
    text: 'Followers'
  },
  {
    value: 'engagementRate',
    text: 'Engagement Rate',
    width: '60px'
  },
  {
    text: 'Avg Likes',
    value: 'avgLikes'
  },
  {
    text: 'Avg Views',
    value: 'avgViews'
  },
  {
    text: 'Avg Cmt.',
    value: 'avgComments'
  },
  {
    text: 'Avg Reel Plays',
    value: 'avgReelPlays'
  },
  {
    value: 'action',
    text: 'Actions',
    sortable: false
  }
]

const iqDataTableHeaders = [
  {
    value: 'handle',
    text: 'Handle'
  },
  {
    value: 'fullName',
    text: 'Full Name'
  },
  {
    value: 'totalFollowers',
    text: 'Followers'
  },
  {
    value: 'engagementRate',
    text: 'Engagement Rate',
    width: '60px'
  },
  {
    value: 'engagements',
    text: 'Engagements',
    width: '60px'
  }
]

export default Object.assign(
  {},
  {
    followerOptions,
    engOptions,
    engRatePercentageOptions,
    percentOptions,
    searchSettings,
    localTableHeaders,
    iqDataTableHeaders
  }
)



// WEBPACK FOOTER //
// ./src/components/views/Influencer/KeywordSearch/config.js